import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Link2, AlertTriangle } from 'lucide-react';
import { ZuordnenDialog } from './ZuordnenDialog';

// Einheitliche Anzeige + Änderung der Register-Zuordnung „Mandant → Akte“ in jedem Bereich
export const ZuordnungChip = ({ item, onDone }) => {
  const [open, setOpen] = useState(false);
  const z = item.zuordnung || {};
  const ok = z.mandanten_nr && z.status !== 'offen';
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`zuordnung-chip-${item.id}`}>
      {ok ? (
        <Link to={`/kanzlei/mandanten/${z.mandanten_nr}`} className="inline-flex items-center gap-1 text-[10px] tracking-wider font-mono px-2 py-0.5 rounded-full bg-[#1B3A5C]/5 text-[#1B3A5C] border border-[#1B3A5C]/15 hover:border-[#b8893d]" title={`Zuordnung: ${z.status === 'manuell' ? `manuell von ${z.von}` : 'automatisch'} – Mandanten-360° öffnen`} data-testid={`zuordnung-label-${item.id}`}>
          M-{z.mandanten_nr}{z.aktenzeichen ? ` · AZ ${z.aktenzeichen}` : ''}
        </Link>
      ) : z.status === 'ignoriert' ? (
        <span className="text-[10px] tracking-wider px-2 py-0.5 rounded-full bg-gray-100 text-[#7a8a99]" data-testid={`zuordnung-label-${item.id}`}>KEIN MANDANT</span>
      ) : (
        <span className="inline-flex items-center gap-1 text-[10px] tracking-wider px-2 py-0.5 rounded-full bg-amber-50 text-amber-800 border border-amber-200" data-testid={`zuordnung-label-${item.id}`}><AlertTriangle className="w-3 h-3" /> NICHT ZUGEORDNET</span>
      )}
      <button type="button" onClick={() => setOpen(true)} title="Mandant → Akte zuordnen" data-testid={`zuordnung-edit-${item.id}`}
        className="inline-flex items-center gap-1 text-[10px] tracking-wider text-[#b8893d] hover:text-[#1B3A5C]"><Link2 className="w-3.5 h-3.5" />{ok ? '' : ' ZUORDNEN'}</button>
      {open && <ZuordnenDialog item={item} onClose={() => setOpen(false)} onDone={() => { setOpen(false); onDone?.(); }} />}
    </span>
  );
};

export default ZuordnungChip;
